module.exports = {"serviceManage":{"homePageColumns":{"insertTime":"新增日期","entryName":"名称","entryTypeText":"分类","orderNumber":"排序","iconUrl":"图标（32*32px）","columnUrl":"链接/栏目","displayed":"发布","operation":"操作"},"serviceColumns":{"insertTime":"新增日期","projectName":"服务项目名称","serviceTypeText":"服务类型","objectTypeText":"服务对象","orderNumber":"排序","introduce":"服务介绍","displayed":"发布","operation":"操作"}}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh.serviceManage.json
// module id = X8Gj
// module chunks = 63 64